import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  copyTrainingWrapper: {},
  copyTrainingBottom: {
    marginTop: 8,
  },
}));
